import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { DragSource, DropTarget } from 'react-dnd';

import { rowTarget, rowSource, addDndContext } from '../../utils/dndHelpers';

import OfferCell from './OfferCell';

class OfferCellWrapper extends Component {
  render() {
    const {
      offer,
      isDragging,
      connectDragSource,
      connectDropTarget,
      hideBrand,
    } = this.props;
    const opacity = isDragging ? 0 : 1;

    return (
      <OfferCell
        key={offer.id}
        brand={offer.brand}
        offer={offer}
        hideBrand={hideBrand}
        style={{ cursor: 'move', opacity }}
        trRef={(tr) => {
          connectDragSource(tr);
          connectDropTarget(tr);
        }}
        isFromBrand={true}
      />
    );
  }
}

const SortableOfferCell = DropTarget('offer', rowTarget, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}))(
  DragSource('offer', rowSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }))(OfferCellWrapper)
);
export class OfferListView extends Component {
  componentDidMount() {
    if (window.location.hash) {
      const hash = window?.location?.hash.split('#');
      const el = document.querySelector(`#${CSS.escape(hash[1])}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  render() {
    let { offers, moveRow, isActive } = this.props;
    const hideBrand = this.props.hideBrand || false;
    const showBrand = !hideBrand;

    return (
      <table className="tables">
        <thead>
          <tr>
            {showBrand && <th>Brand</th>}
            <th>Title</th>
            <th>Start Date</th>
            <th>End Date</th>
            {showBrand && <th />}
          </tr>
        </thead>
        <tbody>
          {offers.map((offer, i) => {
            if (!showBrand && isActive) {
              return (
                <SortableOfferCell
                  key={offer.id}
                  index={i}
                  id={offer.id}
                  offer={offer}
                  hideBrand={hideBrand}
                  moveRow={moveRow}
                />
              );
            } else {
              return (
                <OfferCell
                  key={offer.id}
                  brand={offer.brand}
                  offer={offer}
                  hideBrand={hideBrand}
                  isFromBrand={hideBrand}
                />
              );
            }
          })}
        </tbody>
      </table>
    );
  }
}

export default createFragmentContainer(addDndContext(OfferListView), {
  offers: graphql`
    fragment OfferList_offers on Offer @relay(plural: true) {
      id
      ...OfferCell_offer
    }
  `,
});
